/*
 * cc-vat-validator-it.js
 * Zero-dependency Italian Partita IVA (VAT) syntax + checksum validator.
 * Erstellt: 2026-08-21, WebExecutor Pack WEB-20260821-201212 (Aperigusto).
 *
 * Regel: 11 Ziffern, optionales fuehrendes "IT".
 * Pruefsumme (Modulo-10, gewichtet):
 *   - Ziffern an ungeraden Positionen (1,3,5,7,9; 1-basiert) werden
 *     unveraendert addiert.
 *   - Ziffern an geraden Positionen (2,4,6,8,10) werden verdoppelt;
 *     ist das Ergebnis > 9, wird 9 abgezogen, bevor addiert wird.
 *   - Die Pruefziffer (Position 11) ist so gewaehlt, dass die Summe aller
 *     11 Ziffern modulo 10 gleich 0 ist.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.validateItalianVAT = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function validateItalianVAT(vatNumber) {
    if (typeof vatNumber !== 'string') {
      return { valid: false, error: 'SYNTAX' };
    }

    var raw = vatNumber.trim().toUpperCase();
    if (raw.indexOf('IT') === 0) {
      raw = raw.slice(2);
    }

    if (!/^[0-9]{11}$/.test(raw)) {
      return { valid: false, error: 'SYNTAX' };
    }

    var digits = raw.split('').map(function (d) {
      return parseInt(d, 10);
    });

    var sum = 0;
    for (var i = 0; i < 10; i++) {
      var d = digits[i];
      var position = i + 1; // 1-based
      if (position % 2 === 1) {
        // ungerade Position: unveraendert addieren
        sum += d;
      } else {
        // gerade Position: verdoppeln, bei > 9 neun abziehen
        var doubled = d * 2;
        if (doubled > 9) {
          doubled -= 9;
        }
        sum += doubled;
      }
    }

    var expectedCheckDigit = (10 - (sum % 10)) % 10;
    var actualCheckDigit = digits[10];

    if (expectedCheckDigit !== actualCheckDigit) {
      return { valid: false, error: 'CHECKSUM' };
    }

    return { valid: true, error: null };
  }

  return validateItalianVAT;
});
